import styled from 'styled-components';
import {MapContainer} from 'react-leaflet';

const StyledMapContainer = styled(MapContainer)`
  width: 100%;
  height: 180px;
  border-radius: 10px;

  ${({theme}) => theme.breakpoints.up('sm')} {
    height: 390px;
  }

  .leaflet-popup-content p {
    margin: 8px 0;
  }
`;

export default StyledMapContainer;
